import { render, staticRenderFns } from "./caisse_view.vue?vue&type=template&id=2456d6a4&scoped=true&"
import script from "./caisse_view.vue?vue&type=script&lang=js&"
export * from "./caisse_view.vue?vue&type=script&lang=js&"
import style0 from "./caisse_view.vue?vue&type=style&index=0&id=2456d6a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456d6a4",
  null
  
)

export default component.exports